import Modal from "@src/common/ModalPopup"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { COUNTRY_CODE, FEATURE_LISTING, ROLE, STATUS_SUCCESS, WEBSITE_URL } from '@src/config/constant';
import { shareLoanQuoteDetail } from "@src/store/slices/insurance";
import { toast } from 'react-toastify';
import * as HELPER from '../../../config/helper';
import moment from 'moment';
import { getAddonListID } from "../create/FunctionList";
import InsuranceService from "@src/services/InsuranceService";
import { TENURE } from "@src/config/id/constant";

//import { LEAD_DETAIL_AMOUNT_FIELDS } from "@src/config/id/constant";

export default function ShareQuotesDetailID(props: any) {
    let { show, handleClose,addonList,addonCount,setLoader } = props
    let [selectedRoles, setSelectedRoles] = useState<any>({ customer: false, so: false, agent: false, aro: false, sm: false })
    const [addonByTenure, setAddonByTenure] = useState<any>([]);    
    const [quoteData, setQuoteData] = useState<any>([]);

    let insuranceState = useSelector((state: any) => state.insurance)
    insuranceState = (insuranceState && insuranceState.leadDetail) ? insuranceState.leadDetail : null
    // const insuranceQuotesState = (insuranceState) ? insuranceState.quotes : null;

    let isShareBtnActive = insuranceState?.email || insuranceState?.so_id || insuranceState?.agent_id || insuranceState?.aro_id || insuranceState?.sm_id
    isShareBtnActive = isShareBtnActive ? true : false    

    // const currencyName = COUNTRY_CODE === 'id' ? 'IDR' : 'PHP'
    
    //=========  quotation share variabels start =================//
    
   
    const quotationData: any = useSelector((state: any) => state.insurance.quotationData); 
    let quotationAddonsData: any = useSelector((state: any) => state.insurance.quotationAddonsData);   
    const customer_discount = quotationData.find((row:any)=>row.key==='customer_discount')?.value;
    const car_fmv = quotationData.find((row:any)=>row.key==='car_fmv')?.value;
    const acc_price = quotationData.find((row:any)=>row.key==='acc_price')?.value;
    const total_fmv = quotationData.find((row:any)=>row.key==='total_fmv')?.value;
    const basic_premium_amount = quotationData.find((row:any)=>row.key==='basic_premium_amount')?.value;
    const total_addons_premium = quotationData.find((row:any)=>row.key==='total_addons_premium')?.value;
    const admin_fee = quotationData.find((row:any)=>row.key==='admin_fee')?.value;
    const final_premium = quotationData.find((row:any)=>row.key==='final_premium')?.value;   
    const insurer_name = quotationData.find((row:any)=>row.key==='insurer_name')?.value;   
    const insurance_type_name = quotationData.find((row:any)=>row.key==='insurance_type_id')?.value?.label;   
    const plate_number_region = quotationData.find((row:any)=>row.key==='plate_number_region')?.value; 
    const plate_area = quotationData.find((row:any)=>row.key==='plate_area')?.value?.label;     
    const insurance_starting_date = quotationData.find((row:any)=>row.key==='insurance_starting_date')?.value;
    const vehicle_condition_id = quotationData.find((row:any)=>row.key==='vehicle_condition_id')?.value?.label;
    const model_name = quotationData.find((row:any)=>row.key==='model')?.value?.value;
    const make_year = quotationData.find((row:any)=>row.key==='make_year')?.value?.value;
    const version = quotationData.find((row:any)=>row.key==='version')?.value?.value;
    const make_name = quotationData.find((row:any)=>row.key==='make')?.value?.value;
    if(quotationAddonsData===null){
        quotationAddonsData = insuranceState.addon_detail
    }
    const formatDate = (date: Date, format: string = "dd/mm/yyyy"): string => {
        const day = date.getDate().toString().padStart(2, '0');
        const monthNumeric = (date.getMonth() + 1).toString().padStart(2, '0');
        const monthShort = date.toLocaleString('en-GB', { month: 'short' });
        const monthLong = date.toLocaleString('en-GB', { month: 'long' });
        const year = date.getFullYear().toString();
        const yearShort = year.slice(-2);
        const weekdayShort = date.toLocaleString('en-GB', { weekday: 'short' });
        const weekdayLong = date.toLocaleString('en-GB', { weekday: 'long' });
    
        return format
            .replace(/\bdate\b/g, day)
            .replace(/\bmonth\b/g, monthNumeric)
            .replace(/\bmon\b/g, monthShort)
            .replace(/\bmonthlong\b/g, monthLong)
            .replace(/\byear\b/g, year)
            .replace(/\byy\b/g, yearShort)
            .replace(/\bdd\b/g, day)
            .replace(/\bmm\b/g, monthNumeric)
            .replace(/\byyyy\b/g, year)
            .replace(/\byy\b/g, yearShort)
            .replace(/\bddd\b/g, weekdayShort)
            .replace(/\bdddd\b/g, weekdayLong);
    } 
    const currentDate = formatDate(new Date());
   
    let insuranceType = quoteData?.insurance_all_type;
    if(+insuranceState?.tenure===TENURE){
        insuranceType = insuranceState?.lead_tenure_data?.[0]?.insurance_type_name
    }

    const quotationShareData: Record<string, any> = {
        customer_discount,
        car_fmv,
        acc_price,
        total_fmv,
        basic_premium_amount,
        total_addons_premium,
        admin_fee,
        final_premium,
        insurer_name,
        insurance_type_name,
        plate_number_region,
        plate_area,
        insurance_starting_date,
        vehicle_condition_id,
        model_name,
        make_year,
        version,
        currentDate,
        partner_id:insuranceState?.partner_id,
        insurer_logo:insuranceState?.insurer_logo,
        insurer_id:insuranceState?.insurer_id,
        addon_list:quotationAddonsData,
        make_name,
        addons_by_tenure:addonByTenure,
        insurance_all_type:insuranceType,
        customer_name : insuranceState?.customer_name,
        vehicle_usage : insuranceState?.vehicle_usage,
        vehicle_type : insuranceState?.vehicle_id,
    };
    const total_premium_amount = HELPER.addCurrencyFormatting((HELPER.removeCurrencyFormattingId(basic_premium_amount) as any) + HELPER.removeCurrencyFormattingId(total_addons_premium))
    
    //=========  quotation share variabels end =================//


    const handleBtnClick = async () => {
        props.setLoader(true)

        let params: any = {}
        let share_with_roles = []
        let roleIds = []
        let rolesSelected = selectedRoles
        for (let key in rolesSelected) {
            if (rolesSelected[key]) {
                if (key === 'customer') {
                    params.customer_email = insuranceState.email
                }
                else {
                    params[`${key}_id`] = insuranceState[`${key}_id`]
                    roleIds.push(+insuranceState[`${key}_id`])
                    let allRoles: any = ROLE
                    let roleId = Object.keys(ROLE).find((e: string) => allRoles[e] === `${key}_id`)
                    if (roleId) share_with_roles.push(+roleId)
                }
            }
        }


        if (Object.keys(params).length || COUNTRY_CODE === 'id') {
            let apiParams: any = {}

            if (COUNTRY_CODE === 'id') {
                apiParams.lead_id = insuranceState?.hashId
                apiParams.user_id = insuranceState?.user_id
              for (let row in quotationShareData) {
                const value = quotationShareData[row];

                    if (typeof value === 'string' && value.includes("Rp")) {
                        quotationShareData[row] = HELPER.removeCurrencyFormattingId(value);
                    }
                }
                apiParams.quoationShareData = quotationShareData
            } else {
                apiParams.lead_type = insuranceState?.lead_type
                apiParams.user_id = insuranceState?.user_id
                apiParams.role_ids = roleIds
                apiParams.share_with_roles = share_with_roles
                apiParams.data = {
                    vehicle: `${insuranceState?.make_name} ${insuranceState?.model_name} ${insuranceState?.version_name}`,
                    tenure: insuranceState?.tenure,
                    financier: insuranceState?.financier,
                    vehicle_usage: insuranceState?.vehicle_usage,
                    fmv: insuranceState?.proposed_fmv > 0 ? insuranceState.proposed_fmv : insuranceState?.total_fmv_car,
                    partner_id: insuranceState?.partner_id,
                    gross_premium: insuranceState?.gross_premium,
                    own_theft_damage: insuranceState?.own_theft_damage,
                    lead_id: insuranceState?.hashId,
                    aon_rate: insuranceState?.aon_rate
                }

                let addonDetails = insuranceState && insuranceState.addon_detail
                if (addonDetails) {
                    for (let data of addonDetails) {
                        let name = data.name.trim().replaceAll(' ', '_').toLowerCase()
                        let key = name
                        apiParams.data[key] = data.coverage_amount

                        if (data.id === 3) apiParams.data.seat_capacity = data.seat_capacity + data.extra_seat_capacity

                    }
                }

                if (params.customer_email) apiParams.customer_email = params.customer_email
            }


            let sendMail: any = await shareLoanQuoteDetail(apiParams)

            if (sendMail && sendMail.status && sendMail.status === STATUS_SUCCESS) {
                toast.success("Email Sent Successfully")
                handleClose()
            }

        }

        props.setLoader(false)

    }

    const handleRoleClick = (key: string) => {
        setSelectedRoles((prev: any) => {
            return {
                ...prev,
                [key]: !selectedRoles[key]
            }
        })
    }

    useEffect(() => {getQuotationAddonsData(); }, [insuranceState,show])
    
   const getQuotationAddonsData =  async () => {
       
        try {
            setLoader(true)     
            const params: Record<string, any> = {
            sort_by: "RC",
            vehicle_condition: insuranceState?.vehicle_condition_id,
            insurer_id: insuranceState?.insurer_id,
            insurance_type: insuranceState?.insurance_type_id,
            vehicle_type: insuranceState?.vehicle_type,
            plate_area: insuranceState?.plate_area,
            plate_area_type: +insuranceState?.plate_number_region,
            make: insuranceState?.make,
            make_year: insuranceState?.make_year,
            vehicle_usage: insuranceState?.usage_type,
            rule_engine: insuranceState.rule_engine_id,
            insurance_starting_date: moment(
                insuranceState?.insurance_start_date,
            ).format("YYYY-MM-DD"),
            customer_discount_per: insuranceState?.customer_discount_per,
            customer_discount: 0,
            car_fmv: insuranceState?.car_fmv,
            total_fmv: insuranceState?.total_fmv,
            };
        
            let addonListData = getAddonListID(
            addonList?.basic?.concat(addonList?.special),
            );
            
            params["addon_detail"]  = insuranceState?.addon_detail
            // multi-year: keep each addon limited to the policy years it was saved for
            if (+insuranceState?.tenure > 1 && Array.isArray(insuranceState?.addon_detail_all) && Array.isArray(params.addon_detail)) {
                params.addon_detail = params.addon_detail.map((addon: any) => ({
                    ...addon,
                    tenures: insuranceState.addon_detail_all.filter((row: any) => +row.id === +addon.id && row.tenure).map((row: any) => +row.tenure),
                }))
            }
            delete params.insurance_type;
            params.tenure = insuranceState?.tenure;
            params.multi_year = insuranceState?.lead_tenure_data?.map((row: any) => {
            return {
                insurance_type: row.insurance_type_id,
                dep_rate: row.dep_rate,
                insurance_type_name:row.insurance_type_name
            };
            });
            let result = await InsuranceService.getAddonDetailsID(params);
            if(result?.data?.data?.quotation?.[0]?.addons_by_tenure) {
                setAddonByTenure(result?.data?.data?.quotation?.[0]?.addons_by_tenure)
                setQuoteData(result?.data?.data?.quotation?.[0])
            }
            
        } catch (error) {
            
        }finally{
            setLoader(false)
        }  
   }

    const TenurePremiumRows = ({ data }: { data: any[] }) => {
        if (!Array.isArray(data) || data.length === 0) return null;

        const rows: JSX.Element[] = [];

        data.forEach((row: any, tenureIndex: number) => {
            const tenureLabel = row?.tenure_label || (row?.tenure ? `Tenure ${row.tenure}` : "");
            const startDate = row?.insurance_start_date;
            const endDate = row?.insurance_end_date;
            const dateRange =
                startDate && endDate
                    ? `${moment(startDate).format("DD MMM, YYYY")} - ${moment(endDate).format("DD MMM, YYYY")}`
                    : "";

            rows.push(
                <tr key={`tenure-header-${tenureIndex}`} className="tenure-header">
                    <th>{tenureLabel}</th>
                    <td>{dateRange}</td>
                </tr>
            );

            rows.push(
                <tr key={`tenure-basic-${tenureIndex}`}>
                    <th>Basic Premium</th>
                    <td>{HELPER.addCurrencyFormatting(row?.basic_premium_amount ?? 0)}</td>
                </tr>
            );

            rows.push(
                <tr key={`tenure-addon-total-${tenureIndex}`}>
                    <th>Add Ons Premium</th>
                    <td>{HELPER.addCurrencyFormatting(row?.total_addon_amount ?? 0)}</td>
                </tr>
            );

            (row?.addon_list || []).forEach((addon: any, addonIndex: number) => {
                rows.push(
                    <tr key={`tenure-addon-${tenureIndex}-${addonIndex}`}>
                        <th>{addon?.name || `Add On ${addonIndex + 1}`}</th>
                        <td>{HELPER.addCurrencyFormatting(addon?.premium_amount ?? 0)}</td>
                    </tr>
                );
            });
        });

        return <>{rows}</>;
    };

    

    return (
        <div className="view-timeline-popup image-timeline-popup financer-email-popup share-popup">
            <Modal show={show} handleClose={handleClose} >
                <div className="modal-header">
                    <h2>Share Loan Quotation</h2>
                </div>
                <div className="modal-body" >
                    <div className="financer-email-data"> 
                        <div className="header">
                            <h1>Zen Insure</h1>
                            <p>{WEBSITE_URL}</p>
                            <p>Date: {currentDate}</p>
                        </div>

                        <div className="section">
                            <h2>Vehicle Details</h2>
                            <table className="details">
                                <tr>
                                    <th>Insurance Company</th>
                                    <td>{insurer_name}</td>
                                </tr>
                                <tr>
                                    <th>Insurance Type</th>
                                    <td>{quoteData?.insurance_all_type}</td>
                                </tr>
                                <tr>
                                    <th>Condition</th>
                                    <td>{vehicle_condition_id}</td>
                                </tr>
                                <tr>
                                    <th>Period</th>
                                    <td>{insurance_starting_date}</td>
                                </tr>
                                <tr>
                                    <th>Make Model</th>
                                    <td>{make_name} {model_name}</td>
                                </tr>
                                <tr>
                                    <th>Version</th>
                                    <td>{version}</td>
                                </tr>
                                <tr>
                                    <th>Make Year</th>
                                    <td>{make_year}</td>
                                </tr>
                                <tr>
                                    <th>Plate Area</th>
                                    <td>{plate_area}</td>
                                </tr>
                                <tr>
                                    <th>Estimated TSI</th>
                                    <td>{car_fmv}</td>
                                </tr>
                                <tr>
                                    <th>Price of Accessories</th>
                                    <td>{acc_price}</td>
                                </tr>
                                <tr>
                                    <th>Overall Car Price</th>
                                    <td>{total_fmv}</td>
                                </tr>
                            </table>
                        </div>

                        <div className="section">
                            <h2>Premium Details</h2>
                            <table className="details">
                                <tr>
                                    <th>Company</th>
                                    <td>{insurer_name}</td>
                                </tr>
                                {/* <tr>
                                    <th>Basic Premium</th>
                                    <td>{basic_premium_amount}</td>
                                </tr>
                                <tr>
                                    <th>Total Add Ons</th>
                                    <td>{total_addons_premium}</td>
                                </tr>
                                {quotationAddonsData?.map((row: any, index: number) => (
                                    <tr key={index}>
                                        <th>{row.name}</th>
                                        <td>{HELPER.addCurrencyFormatting(row?.premium_amount?? 0)}</td>
                                    </tr>
                               ))} */}
                                <TenurePremiumRows data={addonByTenure} />
                                <tr>
                                    <th>Total Premium</th>
                                    <td>{total_premium_amount}</td>
                                </tr>
                                {
                                HELPER.removeCurrencyFormattingId(customer_discount) !== 0 && 
                                    <tr>
                                        <th>Discount</th>
                                        <td>{customer_discount}</td>
                                    </tr> 
                                }
                                <tr>
                                    <th>Admin Fee</th>
                                    <td>{admin_fee}</td>
                                </tr>
                                <tr>
                                    <th>Total Insurance Amount</th>
                                    <td>{final_premium}</td>
                                </tr>
                            </table>
                        </div> 
                    </div> 

                    {
                        isShareBtnActive
                            ?
                            <>
                                <div className="email-attech-doc-list">
                                    <h3>Share With</h3>
                                    <ul>
                                        {
                                            FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['SHARE_QUOTATION_WITH']['CUSTOMER'] && insuranceState?.email ?
                                                <li className={selectedRoles.customer ? 'active' : ''} onClick={() => handleRoleClick('customer')}>Customer</li>
                                                : null
                                        }
                                        {
                                            FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['SHARE_QUOTATION_WITH']['SALES_OFFICER'] && insuranceState?.so_id ?
                                                <li className={selectedRoles.so ? 'active' : ''} onClick={() => handleRoleClick('so')}>Sales Officer</li>
                                                : null
                                        }
                                        {
                                            FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['SHARE_QUOTATION_WITH']['AGENT'] && insuranceState?.agent_id ?
                                                <li className={selectedRoles.agent ? 'active' : ''} onClick={() => handleRoleClick('agent')}>Agent</li>
                                                : null
                                        }
                                        {
                                            FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['SHARE_QUOTATION_WITH']['ARO'] && insuranceState?.aro_id ?
                                                <li className={selectedRoles.aro ? 'active' : ''} onClick={() => handleRoleClick('aro')}>ARO</li>
                                                : null
                                        }
                                        {
                                            FEATURE_LISTING['LEAD_DETAILS']['QUOTE_DETAILS']['SHARE_QUOTATION_WITH']['SALES_MANAGER'] && insuranceState?.sm_id ?
                                                <li className={selectedRoles.sm ? 'active' : ''} onClick={() => handleRoleClick('sm')}>Sales Manager</li>
                                                : null
                                        }
                                    </ul>
                                </div>
                                <div className="btn-save-remarks m-xl-t">
                                    <button type="button" className="btn-primary" onClick={() => handleBtnClick()}>Share</button>
                                </div>
                            </>
                            : null
                    }
                </div>
            </Modal>
        </div>
    )
}